'use strict';

const createAircraftmapLegendFactory = require('./main_creator');

module.exports = createAircraftmapLegendFactory({
    viewClass: require('./view.desktop'),
});
